<template>
	<div class="modal is-active">
		<div class="modal-background" @click="onClose"></div>
		<div class="modal-card">
			<header class="modal-card-head">
				<h5 class="modal-card-title title is-5">
					{{ title }}
				</h5>
				<button v-if="showClose" class="delete" aria-label="close" @click="onClose"></button>
			</header>
			<section class="modal-card-body is-danger">
				<flashes :alerts="alerts.data" v-if="alerts && alerts.action === 'modal'"></flashes>
				<div v-if="isNeverReceived" class="column is-fullwidth light-margin-bottom">
					<p class="has-text-weight-bold is-size-5">{{ cardTranslations.blocking.card_never_received }}</p>
				</div>
				<div v-else class="select is-fullwidth is-marged-bottom">
					<select v-model="reason" @change="confirmInput = hasDeliveryAddress">
						<option value="choose" disabled>{{ cardTranslations.blocking.select_question }}</option>
						<option
							v-for="(reason, index) in cardTranslations.blocking.reasons"
							:value="index"
							:key="index"
							class="dropdown-item">
							{{ reason }}
						</option>
					</select>
				</div>
				<div class="column" :class="{'is-loading': blockedPrice.loading}">
					<ul>
						<li v-for="(check, index) in cardTranslations.blocking.checks" class="columns is-mobile is-flex is-paddingless">
							<div class="column is-1"><i class="fa-regular" :class="{
								'fa-check has-text-success': index !== 'delivery_address' || deliveryAddress !== noAddressLabel,
								'fa-triangle-exclamation has-text-warning': index === 'delivery_address' && deliveryAddress === noAddressLabel
							}"></i></div>
							<div class="column">{{ index === 'delivery_address' ? deliveryAddress : check }} <a class="has-text-danger" :href="addAddressUrl" v-if="index === 'delivery_address' && deliveryAddress === noAddressLabel"> {{ noAddressButton }}</a></div>

						</li>
						<li class="columns is-mobile is-flex is-paddingless" v-if="blockedPrice.price > 0">
							<div class="column is-1">
								<i class="fa-regular fa-triangle-exclamation has-text-warning"></i>
							</div>
							<div class="column">{{ cardTranslations.blocking.block_payment.replace(':price', blockedPrice.price) }}</div>
						</li>
					</ul>
				</div>
			</section>
			<section class="modal-card-foot">
				<div class="column is-fullwidth">
					<div v-if="isNeverReceived" class="is-flex is-paddingless is-align-items-center is-marged-bottom">
						<input type="checkbox" id="checkbox" class="is-half-marged-right input-checkbox" v-model="confirmInput">
						<label for="checkbox" class="label">{{ cardTranslations.blocking.confirm_never_received_card }}</label>
					</div>
					<div class="column is-paddingless">
						<button :class="{'is-static': !confirmInput, 'is-danger': confirmInput}"
								class="button is-fullwidth track-action"
								@click="sendConfirm"
								data-ta-event="clientarea-track.employee.cards.card-block.confirm"
								data-ta-action="Click"
								data-ta-label="Employee-page – Cards – Confirm Card block"
								data-ta-page-name="EmployeeOverviewPage"
								:data-ta-payload="JSON.stringify({'cardId': card.card_id, 'name': card.addressLabel, 'block-reason': card.blockReason})"
						>
								{{ cardTranslations.blocking.confirm }}
						</button>
					</div>
					<div class="column is-paddingless mt-1">
						<button class="button is-fullwidth" @click="onClose">{{ cardTranslations.blocking.cancel }}</button>
					</div>
				</div>
			</section>
		</div>
	</div>
</template>

<script>
import {ApiMonizze, LoaderState} from "../../api-monizze";

export default {
	name: 'block-card-modal',
	props: {
		alerts: Object,
		card: Object,
		cardTranslations: Object,
		isNeverReceived: Boolean,
		noAddressLabel: String,
		noAddressButton: String,
		showClose: {type:Boolean, default:true},
		employee: Object,
		apiUrl: String,
		addAddressUrl: String,
		nextDeliveryType: String
	},
	data() {
		return {
			confirmInput: false,
			reason: 'choose',
			blockedPrice: {
				loading: false,
				price: 0,
			}
		}
	},
	methods: {
		sendConfirm() {
			if (this.nextDeliveryType === 'home' && this.card.beneficiaryAddressEmpty)
			{
				addFlashAlert('danger', this.cardTranslations.blocking.missing_benef_address)
				return;
			}
			this.$emit('input', this.isNeverReceived ? 'card_never_received' : this.reason);
			this.$emit('confirm');
			this.onClose();
		},
		onClose() {
			this.confirmInput = false;
			this.$emit('close');
		},
		addressToString(address) {
			return address.street + ' ' +
					address.number + ' ' +
					(address.box !== null ? address.box : '') + ' ' +
					(address.zip_code || address.postalCode) + ' '
					+ address.city;
		}
	},
	computed: {
		deliveryAddress() {
			if (this.nextDeliveryType === 'home' && this.card.beneficiaryAddressEmpty)
			{
				return this.noAddressLabel;
			}
			let address = this.card.nextDeliveryAddress;
			return address ?
				this.cardTranslations.blocking.checks.delivery_address = this.cardTranslations.blocking.checks.delivery_address.replace
				(':address', this.addressToString(address)) :
				this.cardTranslations.blocking.checks.delivery_address = this.noAddressLabel;
		},
		hasDeliveryAddress() {
			return !(this.nextDeliveryType === 'home' && this.card.beneficiaryAddressEmpty);
		},
		title() {
			return this.cardTranslations.blocking.title.replace(':user', this.employee.data.userprofile.full_name);
		}
	},
	mounted: function ()
	{
		(new ApiMonizze(new LoaderState(this.blockedPrice)))
			.loadData(
				{url: this.apiUrl},
				null,
				(response, data)  => {
					var price = data.price
					this.blockedPrice.price = price/100;
				});
	}
}
</script>

<style scoped>
.light-margin-bottom {
	border-bottom: 1px solid #eaeaea;
}
input[type=checkbox] {
	appearance: none;
}

input[type=checkbox]:before {
	font-family: "Font Awesome 6 Pro";
	font-size: 23px;
	color: #1a1e1d;
}

input[type=checkbox]:before {
	content: "\f096";
}

input[type=checkbox]:checked:before {
	content: "\f046";
}
</style>
